/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Haveanyquestions2Inputs */

const en_help_haveanyquestions2 = /** @type {(inputs: Help_Haveanyquestions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have any questions?`)
};

/**
* | output |
* | --- |
* | "Have any questions?" |
*
* @param {Help_Haveanyquestions2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_haveanyquestions2 = /** @type {((inputs?: Help_Haveanyquestions2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Haveanyquestions2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_haveanyquestions2(inputs)
});
export { help_haveanyquestions2 as "help_haveAnyQuestions" }